import { render, staticRenderFns } from "./commentator.vue?vue&type=template&id=66aac69a&scoped=true&"
import script from "./commentator.vue?vue&type=script&lang=js&"
export * from "./commentator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aac69a",
  null
  
)

export default component.exports